// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetReferralSummaryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetReferralSummaryQuery = {
  __typename?: 'Query';
  referralSummary?: {
    __typename?: 'ReferralSummary';
    referralEarnings: number;
    referralCount: number;
  } | null;
};

export type ReferralsUserQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ReferralsUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      referralCode: string;
    } | null;
  } | null;
};

export const GetReferralSummaryDocument = gql`
  query GetReferralSummary {
    referralSummary(
      referralTypes: [CUSTOMER_REFER_CUSTOMER, CUSTOMER_REFER_COACH]
    ) {
      referralEarnings
      referralCount
    }
  }
`;

/**
 * __useGetReferralSummaryQuery__
 *
 * To run a query within a React component, call `useGetReferralSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReferralSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetReferralSummaryQuery,
    GetReferralSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReferralSummaryQuery,
    GetReferralSummaryQueryVariables
  >(GetReferralSummaryDocument, options);
}
export function useGetReferralSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReferralSummaryQuery,
    GetReferralSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReferralSummaryQuery,
    GetReferralSummaryQueryVariables
  >(GetReferralSummaryDocument, options);
}
export function useGetReferralSummarySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetReferralSummaryQuery,
    GetReferralSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetReferralSummaryQuery,
    GetReferralSummaryQueryVariables
  >(GetReferralSummaryDocument, options);
}
export type GetReferralSummaryQueryHookResult = ReturnType<
  typeof useGetReferralSummaryQuery
>;
export type GetReferralSummaryLazyQueryHookResult = ReturnType<
  typeof useGetReferralSummaryLazyQuery
>;
export type GetReferralSummarySuspenseQueryHookResult = ReturnType<
  typeof useGetReferralSummarySuspenseQuery
>;
export type GetReferralSummaryQueryResult = Apollo.QueryResult<
  GetReferralSummaryQuery,
  GetReferralSummaryQueryVariables
>;
export const ReferralsUserDocument = gql`
  query Referrals_User {
    user {
      id
      applicant {
        id
        referralCode
      }
    }
  }
`;

/**
 * __useReferralsUserQuery__
 *
 * To run a query within a React component, call `useReferralsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralsUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferralsUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ReferralsUserQuery,
    ReferralsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ReferralsUserQuery, ReferralsUserQueryVariables>(
    ReferralsUserDocument,
    options,
  );
}
export function useReferralsUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ReferralsUserQuery,
    ReferralsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ReferralsUserQuery, ReferralsUserQueryVariables>(
    ReferralsUserDocument,
    options,
  );
}
export function useReferralsUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ReferralsUserQuery,
    ReferralsUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ReferralsUserQuery,
    ReferralsUserQueryVariables
  >(ReferralsUserDocument, options);
}
export type ReferralsUserQueryHookResult = ReturnType<
  typeof useReferralsUserQuery
>;
export type ReferralsUserLazyQueryHookResult = ReturnType<
  typeof useReferralsUserLazyQuery
>;
export type ReferralsUserSuspenseQueryHookResult = ReturnType<
  typeof useReferralsUserSuspenseQuery
>;
export type ReferralsUserQueryResult = Apollo.QueryResult<
  ReferralsUserQuery,
  ReferralsUserQueryVariables
>;
